import Select, {CSSObjectWithLabel, OptionProps} from 'react-select';
import {usePageText} from '../context/page-text-context';
import {useLocale} from '../context/locale-context';

const COPYRIGHT_YEAR = new Date().getFullYear();

export const Footer = () => {
  const pageText = usePageText();
  const {locale, setLocale} = useLocale();
  const {tracking, english, spanish, language} = pageText;
  const localeOptions = [
    {
      label: english,
      value: 'en',
    },
    {
      label: spanish,
      value: 'es',
    },
  ];

  return (
    <footer
      className="bg-secondary text-white flex flex-col md:flex-row justify-center md:justify-between w-full mt-auto px-8 md:px-28 py-4 font-sans gap-4"
      data-testid="footer">
      {/* Logo and copyright */}
      <div className="flex flex-col gap-4">
        <img alt="Assurant Logo" className="w-[190px] md:w-[148px] h-auto" src={'/assurant-logo.png'} />
        <p className="text-xs">© {COPYRIGHT_YEAR} Assurant, Inc. All rights reserved.</p>
      </div>

      <div className="flex flex-col md:items-end md:gap-4 gap-y-2">
        {/* Language selector */}
        <div className="flex items-center gap-4 md:justify-end" data-testid="language-select">
          <img className="h-[32px] w-auto" src={'/ssl.png'} alt="" />
          <div className="bg-white w-px h-6" />
          <Select
            closeMenuOnSelect
            data-testid="locale-select"
            isSearchable={false}
            menuPlacement="top"
            onChange={(newLocale) => setLocale(newLocale.value)}
            options={localeOptions}
            placeholder={language}
            styles={selectCustomStyles}
            value={locale}
          />
        </div>

        {/* Footer links */}
        <div>
          <div className="underline flex flex-col md:flex-row text-sm gap-2 md:gap-8" data-testid="footer-links">
            <a href="https://www.assurant.com/privacypolicy" rel="noopener noreferrer" target="_blank">
              {tracking.privacyLink}
            </a>
            <a href="https://www.assurant.com/legal-notice" rel="noopener noreferrer" target="_blank">
              {tracking.legalLink}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

const selectCustomStyles = {
  option: (provided: CSSObjectWithLabel, state: OptionProps) => ({
    ...provided,
    fontSize: 'x-small',
    backgroundColor: state.isFocused ? '#0066cc !important' : '#303340 !important',
  }),
  placeholder: (provided: CSSObjectWithLabel) => ({
    ...provided,
    color: 'white',
    fontSize: 'x-small',
  }),
  control: () => ({
    backgroundColor: '#303340',
    border: '1px solid white',
    display: 'flex',
    borderRadius: '4px',
    cursor: 'pointer',
  }),
  indicatorSeparator: () => ({display: 'none'}),
};
